import { render } from "./ConsumablesForm.vue?vue&type=template&id=359ec4c6"
import script from "./ConsumablesForm.vue?vue&type=script&lang=js"
export * from "./ConsumablesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__